import { IonInput, IonItem, IonLabel, IonList } from '@ionic/react';
import StepLayout from './StepLayout';
import { modalToggleStore, userFormStore } from '../../../store/Store';

const Profile1 = () => {
    const detailUserForm = userFormStore.useState((s) => s.detailUserForm);
    const valid = Boolean((detailUserForm.first || '').trim());

    const setFirst = (value) => {
        userFormStore.update((s) => {
            s.detailUserForm = { ...s.detailUserForm, first: value };
        });
    };

    const openSecondPage = () => {
        modalToggleStore.update((s) => {
            s.profilePage = 2;
        });
    };

    const continueOnEnter = (e) => {
        if (e.key === 'Enter' && valid) {
            openSecondPage();
        }
    };

    return (
        <StepLayout
            title='What is your first name?'
            primaryLabel='Continue'
            onPrimary={openSecondPage}
            primaryDisabled={!valid}
            hint={valid ? undefined : 'Enter your first name to continue.'}
        >
            <IonList lines='full'>
                <IonItem>
                    <IonLabel position='stacked'>First name</IonLabel>
                    <IonInput
                        id='profile-first-name'
                        name='given-name'
                        autocomplete='given-name'
                        autocapitalize='words'
                        value={detailUserForm.first}
                        placeholder='Enter first name'
                        onIonChange={(e) => setFirst(e.detail.value || '')}
                        onKeyDown={continueOnEnter}
                    />
                </IonItem>
            </IonList>
        </StepLayout>
    );
};

export default Profile1;
